import React, { useState, useEffect } from 'react';
import Loader from '../../components/Loader';
import Calling from '../../api/Calling';
import { toast } from 'react-toastify';
import generateCaptcha from '../../components/captcha';
import { formatView } from '../../components/formatView';
import { useNavigate } from 'react-router-dom';

const Story = () => {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [selectMulti, setSelectMulti] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const navigate = useNavigate();

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling?.getStory(page, limit);
            if (resp?.status) {
                setData(resp?.data || []);
                setPage(resp?.page || 1);
                setTotalPages(resp?.totalPage || 1);
            } else {
                toast.error(resp?.message);
                setData([]);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    const deleteStory = async () => {
        const content = "You are about to delete selected items. To confirm, please solve this math problem.";
        const check = generateCaptcha(content);
        if (!check) return toast.error('Incorrect answer.');

        setLoader(true);
        try {
            if (selectMulti?.length) {
                const resp = await Calling?.deleteStory({ id: selectMulti });
                if (resp?.status) {
                    toast.success(resp?.message);
                    fetchData();
                    setSelectMulti([]);
                } else {
                    toast.error(resp?.message);
                }
            } else {
                toast.error('Please select story to delete');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = data.map(item => item._id);
            setSelectMulti(allIds);
        } else {
            setSelectMulti([]);
        }
    };

    const handleSelect = (id) => {
        if (selectMulti.includes(id)) {
            setSelectMulti(selectMulti.filter(item => item !== id));
        } else {
            setSelectMulti([...selectMulti, id]);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleViewDetails = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedItem(null);
    };

    useEffect(() => {
        fetchData();
    }, [page, limit]);

    return (
        <>
            {loader ? <Loader loader={loader} /> : (
                <div className="w-full min-h-screen px-4 py-6 mt-16 sm:px-6 lg:px-8 lg:ml-[4.4rem]">
                    <div className="mx-auto">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">Story Management</h1>
                                <p className="mt-1 text-sm text-gray-500">Manage stories for your application</p>
                            </div>
                            <div className="flex space-x-3">
                                {selectMulti.length > 0 && (
                                    <button
                                        onClick={deleteStory}
                                        className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                    >
                                        Delete Selected ({selectMulti.length})
                                    </button>
                                )}
                                <button
                                    onClick={fetchData}
                                    className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-main-blue hover:bg-main-blue/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-main-blue"
                                >
                                    Refresh
                                </button>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="bg-white shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200 ">
                                    <thead className="bg-main-th">

                                        <tr>
                                            <th scope="col" className="pl-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                <input
                                                    type="checkbox"
                                                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                                    checked={selectMulti.length === data.length && data.length > 0}
                                                    onChange={handleSelectAll}
                                                />
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Story
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Views
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Created At
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {data.length > 0 ? (
                                            data.map((item) => (
                                                <tr key={item._id} className="hover:bg-main-thHover">
                                                    <td className="pl-6 py-4 whitespace-nowrap">
                                                        <input
                                                            type="checkbox"
                                                            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                                            checked={selectMulti.includes(item._id)}
                                                            onChange={() => handleSelect(item._id)}
                                                        />
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center">
                                                            <div className="flex-shrink-0 h-10 w-10">
                                                                {item.l_id.l_image ? (
                                                                    <img
                                                                        className="h-10 w-10 rounded-md object-cover"
                                                                        src={item.l_id.l_image}
                                                                        alt={item.l_id.l_name}
                                                                    />
                                                                ) : (
                                                                    <div className="h-10 w-10 rounded-md bg-gray-200 flex items-center justify-center text-gray-500">
                                                                        No Img
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="ml-4">
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {item.l_id.l_name}
                                                                </div>
                                                                <div className="text-sm text-gray-500">
                                                                    {item.l_id.l_pro ? (
                                                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                                                            Pro
                                                                        </span>
                                                                    ) : (
                                                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800">
                                                                            Free
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="text-sm text-gray-900">
                                                            <button onClick={() => navigate(`/views/dashboard/${item._id}`)} className="text-blue-600 hover:text-blue-900 mr-3">
                                                                {formatView(item.l_view || 0)}
                                                            </button>
                                                        </div>
                                                    </td>

                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        {new Date(item.createdAt).toLocaleString()}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium">
                                                        <button
                                                            onClick={() => handleViewDetails(item)}
                                                            className="text-main-blue hover:text-main-blue/80 bg-main-blue/10 hover:bg-main-blue/20 px-3 py-1 rounded-md transition-colors"
                                                        >
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">
                                                    No stories found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                                    <div className="flex-1 flex justify-between sm:hidden">
                                        <button
                                            onClick={() => handlePageChange(page - 1)}
                                            disabled={page === 1}
                                            className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${page === 1
                                                ? "bg-gray-100 text-gray-400"
                                                : "bg-white text-gray-700 hover:bg-gray-50"
                                                }`}
                                        >
                                            Previous
                                        </button>
                                        <button
                                            onClick={() => handlePageChange(page + 1)}
                                            disabled={page === totalPages}
                                            className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${page === totalPages
                                                ? "bg-gray-100 text-gray-400"
                                                : "bg-white text-gray-700 hover:bg-gray-50"
                                                }`}
                                        >
                                            Next
                                        </button>
                                    </div>
                                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                                        <div>
                                            <p className="text-sm text-gray-700">
                                                Showing <span className="font-medium">{data.length > 0 ? (page - 1) * limit + 1 : 0}</span> to{" "}
                                                <span className="font-medium">
                                                    {Math.min(page * limit, (totalPages - 1) * limit + data.length)}
                                                </span>{" "}
                                                of <span className="font-medium">{totalPages * limit}</span> results
                                            </p>
                                        </div>
                                        <div>
                                            <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                                                <button
                                                    onClick={() => handlePageChange(page - 1)}
                                                    disabled={page === 1}
                                                    className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${page === 1 ? "text-gray-300" : "text-gray-500 hover:bg-gray-50"
                                                        }`}
                                                >
                                                    <span className="sr-only">Previous</span>
                                                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                        <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                                                    </svg>
                                                </button>

                                                {/* Page numbers */}
                                                {[...Array(totalPages)].map((_, i) => (
                                                    <button
                                                        key={i}
                                                        onClick={() => handlePageChange(i + 1)}
                                                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium ${page === i + 1
                                                            ? "z-10 bg-indigo-50 border-indigo-500 text-indigo-600"
                                                            : "bg-white text-gray-500 hover:bg-gray-50"
                                                            }`}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                ))}

                                                <button
                                                    onClick={() => handlePageChange(page + 1)}
                                                    disabled={page === totalPages}
                                                    className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${page === totalPages ? "text-gray-300" : "text-gray-500 hover:bg-gray-50"
                                                        }`}
                                                >
                                                    <span className="sr-only">Next</span>
                                                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                                    </svg>
                                                </button>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* View Details Modal */}
                    {showModal && selectedItem && (
                        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm overflow-y-auto h-full w-full z-[9999]  flex justify-center items-center">
                            <div className="relative mx-auto p-0 border-0 w-full max-w-3xl shadow-xl rounded-xl bg-white overflow-hidden animate-fadeIn mt-20">
                                {/* Header with gradient background */}
                                <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-4 flex justify-between items-center">
                                    <h3 className="text-xl font-bold tracking-tight flex items-center gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                        </svg>
                                        Story Details
                                    </h3>
                                    <button
                                        onClick={closeModal}
                                        className="text-white bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-1.5 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white"
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>

                                {/* Modal content with card style */}
                                <div className="p-6">
                                    <div className="flex flex-col md:flex-row gap-6 mb-6">
                                        <div className="md:w-2/5">
                                            {selectedItem.l_id.l_image ? (
                                                <div className="relative rounded-xl overflow-hidden shadow-lg border border-gray-100 aspect-square">
                                                    <img
                                                        src={selectedItem.l_id.l_image}
                                                        alt={selectedItem.l_id.l_name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                    {/* Status badge overlay */}
                                                    <div className="absolute top-3 right-3">
                                                        <span className={`px-3 py-1 text-xs font-bold rounded-full shadow-md ${selectedItem.l_id.l_status
                                                            ? "bg-green-500 text-white"
                                                            : "bg-red-500 text-white"
                                                            }`}>
                                                            {selectedItem.l_id.l_status ? "ACTIVE" : "INACTIVE"}
                                                        </span>
                                                    </div>
                                                    {/* Pro/Free badge overlay */}
                                                    <div className="absolute top-3 left-3">
                                                        <span className={`px-3 py-1 text-xs font-bold rounded-full shadow-md ${selectedItem.l_id.l_pro
                                                            ? "bg-gradient-to-r from-yellow-400 to-yellow-600 text-white"
                                                            : "bg-gray-700 text-white"
                                                            }`}>
                                                            {selectedItem.l_id.l_pro ? "PRO" : "FREE"}
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="w-full rounded-xl bg-gray-100 aspect-square flex flex-col items-center justify-center text-gray-400 border border-gray-200">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-2 opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                    </svg>
                                                    <p className="font-medium">No Image Available</p>
                                                </div>
                                            )}

                                            {/* View statistics card */}
                                            <div className="mt-4 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
                                                <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3 flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                        <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                                        <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                                                    </svg>
                                                    View Statistics
                                                </h4>
                                                <div className="flex justify-between">
                                                    <div className="text-center p-2 bg-indigo-50 rounded-lg flex-1 mr-2">
                                                        <p className="text-xs text-indigo-600 font-medium">Story Views</p>
                                                        <p className="text-xl font-bold text-indigo-700">{selectedItem.l_view}</p>
                                                    </div>
                                                    <div className="text-center p-2 bg-purple-50 rounded-lg flex-1">
                                                        <p className="text-xs text-purple-600 font-medium">List Views</p>
                                                        <p className="text-xl font-bold text-purple-700">{selectedItem.l_id.l_view}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="md:w-3/5 flex flex-col">
                                            {/* Story info */}
                                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 mb-4">
                                                <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3 flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                                    </svg>
                                                    Story Information
                                                </h4>

                                                <div className="grid grid-cols-1 gap-3">
                                                    <div className="flex items-center">
                                                        <div className="w-1/3 text-sm font-medium text-gray-500">Name</div>
                                                        <div className="w-2/3 text-sm font-semibold text-gray-800 bg-gray-50 p-2 rounded">{selectedItem.l_id.l_name}</div>
                                                    </div>

                                                    <div className="flex items-center">
                                                        <div className="w-1/3 text-sm font-medium text-gray-500">ID</div>
                                                        <div className="w-2/3 text-sm font-mono text-gray-800 bg-gray-50 p-2 rounded overflow-auto text-xs">{selectedItem._id}</div>
                                                    </div>

                                                    <div className="flex items-center">
                                                        <div className="w-1/3 text-sm font-medium text-gray-500">Created</div>
                                                        <div className="w-2/3 text-sm text-gray-800 bg-gray-50 p-2 rounded">
                                                            {new Date(selectedItem.createdAt).toLocaleString(undefined, {
                                                                year: 'numeric',
                                                                month: 'short',
                                                                day: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </div>
                                                    </div>

                                                    <div className="flex items-center">
                                                        <div className="w-1/3 text-sm font-medium text-gray-500">Updated</div>
                                                        <div className="w-2/3 text-sm text-gray-800 bg-gray-50 p-2 rounded">
                                                            {new Date(selectedItem.updatedAt).toLocaleString(undefined, {
                                                                year: 'numeric',
                                                                month: 'short',
                                                                day: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Prompt */}
                                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 mb-4 flex-grow">
                                                <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3 flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z" clipRule="evenodd" />
                                                    </svg>
                                                    Prompt
                                                </h4>
                                                <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 overflow-auto max-h-32 prose prose-sm">
                                                    <p className="text-sm text-gray-700 whitespace-pre-wrap">{selectedItem.l_id.l_prompt}</p>
                                                </div>
                                            </div>

                                            {/* Models */}
                                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
                                                <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3 flex items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                        <path d="M13 7H7v6h6V7z" />
                                                        <path fillRule="evenodd" d="M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z" clipRule="evenodd" />
                                                    </svg>
                                                    Models
                                                </h4>
                                                <div className="flex flex-wrap gap-2">
                                                    {selectedItem.l_id.l_model && selectedItem.l_id.l_model.map((model, index) => (
                                                        <span key={index} className="px-3 py-1.5 bg-indigo-50 text-indigo-700 text-xs font-medium rounded-md border border-indigo-100">
                                                            {model}
                                                        </span>
                                                    ))}
                                                </div>

                                                {selectedItem.l_id.l_model_recommended && (
                                                    <div className="mt-3 bg-gradient-to-r from-purple-50 to-indigo-50 p-3 rounded-lg border border-purple-100">
                                                        <p className="text-xs font-medium text-purple-800 flex items-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clipRule="evenodd" />
                                                            </svg>
                                                            Recommended Model
                                                        </p>
                                                        <p className="mt-1 text-sm font-semibold text-purple-900">{selectedItem.l_id.l_model_recommended}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-between items-center">
                                    <div className="text-xs text-gray-500">
                                        Last updated: {new Date(selectedItem.updatedAt).toLocaleString()}
                                    </div>
                                    <button
                                        onClick={closeModal}
                                        className="px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default Story;